import React from 'react';

const CheckboxButtonWithLabel = ({
    defaultChecked = false,
    handleDelete = ()=> {},
    handleClick = () => {},
    id = "",
    label = "label",
    removed_from_selected = false,
    deleteButton = false,
    theme = "default"
}) => {
    return (
        <div>
            <input
            type="checkbox"
            className="text-white btn-check"
            name="options-outlined"
            id={`success-outlined${id}`}
            autoComplete="off"
            defaultChecked={defaultChecked}
            onClick={handleClick}
            />
            <label
            className={`btn btn-outline-${
                theme
            } btn-sm`}
            htmlFor={`success-outlined${id}`}
            >
                <span>{label}</span>
                {
                    deleteButton && <button className="p-0 btn ms-1" onClick={handleDelete}>
                        <svg
                            width="19"
                            height="19"
                            viewBox="0 0 19 19"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                            d="M14 5L5 14"
                            stroke="#091CAA"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            />
                            <path
                            d="M5 5L14 14"
                            stroke="#091CAA"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            />
                        </svg>
                    </button>
                }
            </label>
        </div>
    )
}

export default CheckboxButtonWithLabel;